import { addPharmacyToPatientByUserId } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { AddPatientPharmacyRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchAddPharmacyToPatientByUserId(
  userId: string,
  data: AddPatientPharmacyRequestT,
  signal?: AbortSignal
): Promise<unknown> {
  const config = await createLotusRequestConfig({ signal });
  const response = await addPharmacyToPatientByUserId(userId, data, config);
  return lotusHealthZod.addPharmacyToPatientByUserIdResponse.parse(response.data);
}
